import React from "react";
import PropTypes from "prop-types";

import { IntlProvider } from "react-intl";
import { translations } from "../../util/i18n";
import PayloadJSONView from './PayloadJSONView';

const PayloadOverviewModal = ({payload}) => {
  return (
    <IntlProvider
      locale={window._FLAIM_LOCALE}
      key={window._FLAIM_LOCALE}
      messages={translations[window._FLAIM_LOCALE]}
    >
      <PayloadJSONView payload={payload}/>
    </IntlProvider>
  );
};

PayloadOverviewModal.propTypes = {
  payload: PropTypes.string.isRequired,
};

export default PayloadOverviewModal;
